
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { FaUsers, FaSitemap, FaFileExcel, FaPlus, FaUserAlt, FaMobileAlt, FaRegListAlt, FaTrashAlt, FaEdit } from 'react-icons/fa';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import axios from 'axios';

const AddContactForm = () => {

  const [groupName, setGroupName] = useState('');
  const [subgroupName, setSubgroupName] = useState('');
  const [contacts, setContacts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [currentContact, setCurrentContact] = useState(null);
  const [newName, setNewName] = useState('');
  const [newMobile, setNewMobile] = useState('');
  const [newSubgroupId, setNewSubgroupId] = useState('');
  const [groupOptions, setGroupOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const contactsPerPage = 10;

  const handleDownloadDemoExcel = () => {
    const demoData = [
      { Name: 'Ramana', Mobile: '9876543210' },
      { Name: 'Smith', Mobile: '9123456789' },
      { Name: 'Alice', Mobile: '9988776655' },
    ];
    const ws = XLSX.utils.json_to_sheet(demoData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Contacts');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'contacts_demo.xlsx';
    link.click();
  };
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  };


  // new 18/2/2024
  const [newGroup1, setNewGroup1] = useState('');
  const [groups1, setGroups1] = useState([]);
  const [selectedGroup1, setSelectedGroup1] = useState('');

  const fetchGroups1 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    axios.get(`https://rvapi.emedha.in/pages/api/api/groups?userId=${user.id}`)
      .then(response => {
        setGroups1(response.data);
      })
      .catch(error => {
        console.error('Error fetching groups:', error);
      });
  };


  useEffect(() => {
    fetchGroups1();
  }, []);

  const handleAddGroup1 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user || !user.id) {
      alert('User not logged in');
      return;
    }
    axios.post('https://rvapi.emedha.in/pages/api/api/groups', {
      name: newGroup1,
      user_id: user.id,
    })
      .then(response => {
        console.log(response);
        alert('Group created successfully!');
        fetchGroups1();
        fetchGroup2();
        setNewGroup1('');
      })
      .catch(error => {
        console.error('Error creating group:', error);
        alert('Error creating group');
      });
  };


  const handleGroupChange1 = (e) => {
    setSelectedGroup1(e.target.value);
  };

  const [newSubgroup1, setNewSubgroup1] = useState('');
  const handleAddSubgroup1 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    if (!user || !user.id) {
      alert('User not logged in');
      return;
    }

    if (!selectedGroup1 || !newSubgroup1.trim()) {
      alert('Both group and subgroup name are required!');
      return;
    }

    const selectedGroup = groups1.find(group => group.name === selectedGroup1);
    if (!selectedGroup) {
      alert('Group not found!');
      return;
    }

    const payload = {
      name: newSubgroup1,
      group_id: selectedGroup.id,
      user_id: user.id, // 👈 include user ID
    };

    axios.post('https://rvapi.emedha.in/pages/api/api/subgroups', payload)
      .then(response => {
        console.log('Subgroup added successfully', response);
        alert('Subgroup added successfully!');
        setNewSubgroup1('');
        fetchSubGroups1();
      })
      .catch(error => {
        console.error('Error adding subgroup:', error);
        alert('Error adding subgroup');
      });
  };


  const [subgroups1, setSubgroups1] = useState([]);
  const [selectedSubgroup1, setSelectedSubgroup1] = useState('');

  const fetchSubGroups1 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    if (!user || !user.id) {
      console.error('User not logged in');
      return;
    }

    axios.get(`https://rvapi.emedha.in/pages/api/api/subgroups?user_id=${user.id}`)
      .then(response => {
        setSubgroups1(response.data);
      })
      .catch(error => {
        console.error('Error fetching subgroups:', error);
      });
  };


  useEffect(() => {
    fetchSubGroups1();
  }, []);

  const handleSubgroupChange1 = (e) => {
    setSelectedSubgroup1(e.target.value);
  };

  const [groups2, setGroups2] = useState([]);
  const [selectedGroup2, setSelectedGroup2] = useState('');

  const fetchGroup2 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    if (!user || !user.id) {
      console.error('User not logged in');
      return;
    }

    axios.get(`https://rvapi.emedha.in/pages/api/apiwer/groups?user_id=${user.id}`)
      .then(response => {
        setGroups2(response.data);
      })
      .catch(error => {
        console.error('Error fetching groups:', error);
      });
  };

  useEffect(() => {
    fetchGroup2()
  }, []);

  const handleGroupChange2 = (e) => {
    setSelectedGroup2(e.target.value);
  };

  const handleFileUpload = (e) => {
    if (!selectedGroup2) {
      alert('Please select a group before uploading contacts.');
      return;
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user || !user.id) {
      alert('User not logged in.');
      return;
    }

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const sheetData = XLSX.utils.sheet_to_json(sheet);

        const parsedContacts = sheetData.map((row) => {
          const mobileNumber = row.Mobile ? String(row.Mobile).trim() : '';
          const phoneNumber = parsePhoneNumberFromString(mobileNumber);
          const formattedNumber = phoneNumber ? phoneNumber.formatInternational() : mobileNumber;

          return {
            name: row.Name,
            mobile: formattedNumber,
          };
        });

        axios.post('https://rvapi.emedha.in/pages/api/uploadfile-contacts', {
          groupId: selectedGroup2,
          subgroupId: selectedSubgroup1 || '',
          contacts: parsedContacts,
          user_id: user.id, // ✅ Send user ID
        })
          .then((response) => {
            alert('Contacts uploaded successfully');
          })
          .catch((error) => {
            console.error('Error uploading contacts:', error);
            alert('Failed to upload contacts');
          });
      };
      reader.readAsArrayBuffer(file);
      e.target.value = '';
    }
  };






  // view Data


  const [groupedContacts, setGroupedContacts] = useState({});
  const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);

  const fetchGroups = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      if (!user || !user.id) {
        console.error('User not logged in');
        return;
      }

      const queryParams = new URLSearchParams();
      queryParams.append('user_id', user.id); // ✅ Include user_id
      if (groupName) queryParams.append('groupName', groupName);
      if (subgroupName) queryParams.append('subgroupName', subgroupName);

      const response = await fetch(`https://rvapi.emedha.in/pages/api/contacts?${queryParams.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch contacts');
      }

      const data = await response.json();

      const groupedData = data.contacts.reduce((acc, contact) => {
        const group = contact.group_name;
        const subgroup = contact.subgroup_name || 'No Subgroup';
        if (!acc[group]) {
          acc[group] = {};
        }
        if (!acc[group][subgroup]) {
          acc[group][subgroup] = [];
        }
        acc[group][subgroup].push({
          ...contact,
          group_id: contact.group_id,
          subgroup_id: contact.subgroup_id,
        });
        return acc;
      }, {});

      setGroupedContacts(groupedData);
      const groups = Object.keys(groupedData);
      setGroupOptions(groups);

      if (groupName) {
        const subgroup = subgroupName || 'No Subgroup';
        const selectedContacts = groupedData[groupName][subgroup] || [];
        setSelectedGroupContacts(selectedContacts);
      }

    } catch (err) {
      console.error('Error fetching contacts:', err);
    }
  };


  const handleGroupChange = (e) => {
    setGroupName(e.target.value);
    setSubgroupName('');
    setSelectedGroupContacts([]);
  };

  const handleSubgroupChange = (e) => {
    const subgroup = e.target.value;
    setSubgroupName(subgroup);
    const selectedContacts = groupedContacts[groupName][subgroup || 'No Subgroup'] || [];
    setSelectedGroupContacts(selectedContacts);
  };


  const fetchContacts = async () => {
    try {
      const url = new URL('https://rvapi.emedha.in/pages/api/contacts');
      if (groupName) url.searchParams.append('groupName', groupName);
      if (subgroupName) url.searchParams.append('subgroupName', subgroupName);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch contacts');
      const data = await response.json();
      setContacts(data.contacts);
    } catch (err) {
      setContacts([]);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  useEffect(() => {
    if (groupName || subgroupName) {
      fetchContacts();
    }
  }, [groupName, subgroupName]);

  const handleEdit = (contact) => {
    setIsEditing(true);
    setCurrentContact(contact);
    setNewName(contact.contact_name);
    setNewMobile(contact.contact_mobile);
    setNewSubgroupId(contact.subgroup_id);
  };

  const handleUpdateContact = async () => {
    if (!currentContact?.id) {
      alert('Contact ID is missing!');
      return;
    }
    try {
      const contactData = {
        name: newName,
        mobile: newMobile,
        groupId: currentContact.groupId,
        subgroupId: newSubgroupId !== undefined ? newSubgroupId : currentContact.subgroupId,
      };
      const response = await fetch(`https://rvapi.emedha.in/pages/api/update-contact/${currentContact.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(contactData),
      });
      const result = await response.json();
      if (response.ok) {
        alert('Contact updated successfully');
        fetchContacts();
        setIsEditing(false);
      } else {
        alert(result.error || 'Failed to update contact');
      }
    } catch (err) {
      console.error('Error updating contact:', err);
    }
  };

  const handleDelete = async (contactId) => {
    if (!contactId) {
      alert('Contact ID is missing!');
      return;
    }
    try {
      const response = await fetch(`https://rvapi.emedha.in/pages/api/delete-contact/${contactId}`, {
        method: 'DELETE',
      });
      const result = await response.json();
      if (response.ok) {
        alert('Contact deleted successfully');
        fetchContacts();
      } else {
        alert(result.error || 'Failed to delete contact');
      }
    } catch (err) {
      console.error('Error deleting contact:', err);
      alert('An error occurred while deleting the contact');
    }
  };

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredContacts = contacts.filter(contact => {
    const searchLower = searchQuery.toLowerCase();
    return (
      contact.contact_name.toLowerCase().includes(searchLower) ||
      contact.contact_mobile.includes(searchLower)
    );
  });
  const paginatedContacts = filteredContacts.slice(
    (currentPage - 1) * contactsPerPage,
    currentPage * contactsPerPage
  );
  const totalPages = Math.ceil(filteredContacts.length / contactsPerPage);
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  // model form data 


  const [showModal, setShowModal] = useState(false);
  const [groups, setGroups] = useState([]);
  const [subgroups, setSubgroups] = useState([]);

  const openModal = async () => {
    setShowModal(true);
    await fetchData();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const fetchData = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      if (!user || !user.id) {
        console.error('User not logged in');
        return;
      }

      const queryString = `?user_id=${user.id}`;

      const groupRes = await axios.get(`https://rvapi.emedha.in/pages/api/apiget/groups${queryString}`);
      const subgroupRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/subgroups${queryString}`);

      setGroups(groupRes.data);
      setSubgroups(subgroupRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Failed to fetch data.');
    }
  };


  const handleDeleteSubgroup = async (subgroupId) => {
    if (window.confirm('Are you sure you want to delete this subgroup and its contacts?')) {
      try {
        await axios.delete(`https://rvapi.emedha.in/pages/api/api/subgroups/${subgroupId}`);
        alert('Subgroup deleted successfully.');
        await fetchData();
      } catch (error) {
        console.error('Error deleting subgroup:', error);
        alert('Failed to delete subgroup.');
      }
    }
  };

  const handleDeleteGroup = async (groupId) => {
    if (window.confirm('Are you sure you want to delete this group, its subgroups, and contacts?')) {
      try {
        await axios.delete(`https://rvapi.emedha.in/pages/api/api/groups/${groupId}`);
        alert('Group deleted successfully.');
        await fetchData();
      } catch (error) {
        console.error('Error deleting group:', error);
        alert('Failed to delete group.');
      }
    }
  };


  return (
    <>
      <div className="container">
        <div className="row p-2" style={{ border: 'solid 1px black' }} >
          <div className="col-6 p-3 rounded">
            <label htmlFor="newGroup" className="form-label"><FaUsers className="me-2" />Create Group</label>
            <div className="d-flex align-items-center">
              <input type="text" id="newGroup1" className="form-control w-75" value={newGroup1} onChange={(e) => setNewGroup1(e.target.value)} placeholder="Enter Group Name" style={{ border: 'solid 1px black' }} />
              <button className="btn btn-primary ms-2 px-4 btn-sm py-1" onClick={handleAddGroup1}><FaPlus className="me-2" />Create</button>
            </div>
          </div>
          <div className="col-6 mt-4">
            <label htmlFor="groupSelect1" className="form-label"><FaUsers className="me-2" />If you want to create a sub-group, click here.</label>
            <select id="groupSelect1" className="form-select" value={selectedGroup1} onChange={handleGroupChange1} style={{ border: 'solid 1px black' }}>
              <option value="" disabled>Select a Group</option>
              {groups1.map((group, index) => (
                <option key={index} value={group.name}>{group.name}</option>))}
            </select>
          </div>
        </div>
        <div className="row mb-3">
          {selectedGroup1 && (
            <div className="col-6 p-3 mt-2" style={{ border: 'solid 1px black' }}>
              <label htmlFor="newSubgroup1" className="form-label fs-5 fw-semibold"><FaSitemap className="me-2" />Create SubGroup</label>
              <div className="d-flex align-items-center">
                <input type="text" id="newSubgroup1" className="form-control w-75" value={newSubgroup1} onChange={(e) => setNewSubgroup1(e.target.value)} placeholder="Enter new subgroup name" style={{ border: 'solid 1px black' }} />
                <button className="btn btn-primary ms-2 px-4 btn-sm py-1" onClick={handleAddSubgroup1}>
                  <FaPlus className="me-2" /> Add
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="row p-3" style={{ border: 'solid 1px black' }}>
          <label><FaFileExcel className="me-2" />Upload the bulk contact data here.</label>
          <div className="col-3">
            <label htmlFor="groupSelect2" className="form-label"><FaUsers className="me-2" /> Select Group</label>
            <select id="groupSelect2" className="form-select" value={selectedGroup2} onChange={handleGroupChange2} style={{ border: 'solid 1px black' }}>
              <option value="" disabled>Select a group</option>{groups2.map((group, index) => (<option key={index} value={group.id}>{group.name}</option>))}</select>
          </div>
          <div className="col-3">
            <label htmlFor="subgroupSelect1" className="form-label"><FaSitemap className="me-2" /> Select SubGroup</label>
            <select id="subgroupSelect1" className="form-select" value={selectedSubgroup1} onChange={handleSubgroupChange1} style={{ border: 'solid 1px black' }}>
              <option value="" disabled>Select a Subgroup</option>
              {subgroups1.map((subgroup, index) => (<option key={index} value={subgroup.id}>{subgroup.name}</option>))}
            </select>
          </div>
          <div className="col-3">
            <label htmlFor="contactFile" className="form-label"><FaFileExcel className="me-2" />Upload Contacts (Excel)</label>
            <input type="file" className="form-control" id="contactFile" accept=".xlsx,.xls" onChange={handleFileUpload} style={{ border: 'solid 1px black' }} />
          </div>
          <div className="col-3">
            <label htmlFor="contactFile" className="form-label"><FaFileExcel className="me-2" />How to Upload Contacts Demo (Excel) <button className="btn btn-sm btn-success" onClick={handleDownloadDemoExcel}>Download</button></label>
          </div>
        </div>
      </div>

      <>
        <div className="container mt-1 p-2">
          <h3 className="mb-2">CONTACTS DATA</h3>
          <div className="mb-2 p-2" style={{ border: 'solid 1px black' }}>
            <div className="row">
              <div className="col-6">
                <select value={groupName} onChange={handleGroupChange} className="form-control mb-2" style={{ border: 'solid 1px black' }}>
                  <option value="">Select Group</option>
                  {groupOptions.map((group, index) => (<option key={index} value={group}>{group}</option>))}
                </select>
              </div>
              <div className="col-6">
                {groupName && (
                  <select value={subgroupName} onChange={handleSubgroupChange} className="form-control mb-2" style={{ border: 'solid 1px black' }}>
                    <option value="">Select Subgroup (optional)</option>
                    {Object.keys(groupedContacts[groupName]).map((subgroup, index) => (
                      <option key={index} value={subgroup}>{subgroup}</option>))}
                  </select>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <input type="text" value={searchQuery} onChange={handleInputChange} className="form-control" placeholder="Search by Name or Mobile" style={{ border: 'solid 1px black' }} />
              </div>

              <div className="col-6">
                <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'solid 1px black', borderRadius: '5px', cursor: 'pointer' }} onClick={openModal}>If You Want To Delete Group On Click</button>
              </div>

            </div>
          </div>

          <table className="table table-striped table-bordered" style={{ border: 'solid 1px black' }}>
            <thead>
              <tr>
                <th><FaUserAlt /> Contact Name</th>
                <th><FaMobileAlt /> Mobile</th>
                <th><FaUsers /> Group</th>
                <th><FaRegListAlt /> Subgroup</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedContacts.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">No contacts found</td>
                </tr>
              ) : (
                paginatedContacts.map((contact, index) => (
                  <tr key={index}>
                    <td>{contact.contact_name}</td>
                    <td>{contact.contact_mobile}</td>
                    <td>{contact.group_name}</td>
                    <td>{contact.subgroup_name || 'No Subgroup'}</td>
                    <td>
                      <button className="btn btn-warning btn-sm" onClick={() => handleEdit(contact)}><FaEdit /> </button>
                      <button className="btn btn-danger btn-sm ms-2" onClick={() => { handleDelete(contact.id); }}><FaTrashAlt /></button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-between">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="btn btn-sm btn-secondary" style={{ border: 'solid 1px black' }}>Previous</button>
            <div className="text-center"> Page {currentPage} of {totalPages}</div>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="btn btn-sm btn-secondary" style={{ border: 'solid 1px black' }}>Next</button>
          </div>

          {isEditing && (
            <div className="mt-4">
              <h4>Edit Contact</h4>
              <div>
                <input type="text" value={newName} onChange={(e) => setNewName(e.target.value)} className="form-control mb-2" placeholder="Contact Name" style={{ border: 'solid 1px black' }} />
                <input type="text" value={newMobile} onChange={(e) => setNewMobile(e.target.value)} className="form-control mb-2" placeholder="Mobile" style={{ border: 'solid 1px black' }} />
                <button onClick={handleUpdateContact} className="btn btn-sm btn-primary mt-2">Update</button>
                <button onClick={() => setIsEditing(false)} className="btn btn-sm btn-secondary mt-2 ms-2">Cancel</button>
              </div>
            </div>
          )}
        </div>
      </>

      {showModal && (
        <div className="modal show fade d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Groups and Subgroups</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered" style={{ border: 'solid 1px black' }}>
                  <thead className="table-dark">
                    <tr>
                      <th>Group ID</th>
                      <th>Group Name</th>
                      <th>Subgroup ID</th>
                      <th>Subgroup Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groups.map((group) => {
                      const relatedSubgroups = subgroups.filter((sub) => sub.group_id === group.id);
                      return relatedSubgroups.length > 0 ? (
                        relatedSubgroups.map((sub, index) => (
                          <tr key={sub.id}>
                            {index === 0 && (
                              <>
                                <td rowSpan={relatedSubgroups.length}>{group.id}</td>
                                <td rowSpan={relatedSubgroups.length}>{group.name}</td>
                              </>
                            )}
                            <td>{sub.id}</td>
                            <td>{sub.name}</td>
                            <td><button className="btn btn-sm btn-danger" onClick={() => handleDeleteSubgroup(sub.id)}>Delete</button></td>
                          </tr>
                        ))
                      ) : (
                        <tr key={group.id}>
                          <td>{group.id}</td>
                          <td>{group.name}</td>
                          <td colSpan={2} className="text-muted text-center">No subgroups</td>
                          <td><button className="btn btn-sm btn-danger" onClick={() => handleDeleteGroup(group.id)}>Delete</button></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default AddContactForm;


